import { validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import {
  FILTER_ENDPOINT,
  TRANSPORTADOR_INTERNACIONAL_ENDPOINT,
} from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    TRANSPORTADOR_INTERNACIONAL_ENDPOINT
  ]);
}

export async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      TRANSPORTADOR_INTERNACIONAL_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

export async function fetchById(id) {
  return doGetQCXRequest([
    TRANSPORTADOR_INTERNACIONAL_ENDPOINT,
    id,
  ]);
}

export async function register(data, queryParams = []) {
  return doPostQCXRequest(
    [TRANSPORTADOR_INTERNACIONAL_ENDPOINT],
    data,
    queryParams
  );
}

export async function save(data, queryParams = []) {
  return doPutQCXRequest(
    [TRANSPORTADOR_INTERNACIONAL_ENDPOINT],
    data,
    queryParams
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [TRANSPORTADOR_INTERNACIONAL_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [TRANSPORTADOR_INTERNACIONAL_ENDPOINT],
    id
  );
}
